/* Copyright (c) 2020-present CloudIO Inc */

import { SelectItem } from 'componentregistry/components/Select/Select';
import { pageAtom } from 'designer/atoms';
import {
  AnalyzeContext,
  AnalyzeIssue,
  AnalyzeResult,
} from 'layout/Sidebar/panels/TreeView/AnalyzeUtils';
import { Item } from '../../registry/Component.type';

export async function analyzeActionQuerySelect({
  page,
  itemId,
  mgr,
  platform,
  appUid,
  pageId,
}: AnalyzeContext): Promise<AnalyzeResult> {
  const alerts: AnalyzeIssue[] = [];
  const autoFixes: (() => void)[] = [];
  const item = page[itemId] as Item<'ActionQuerySelect'>;
  const { selectItemId } = item.props;
  if (selectItemId) {
    const selectItem = platform.getItem(
      appUid,
      pageId,
      selectItemId,
    ) as SelectItem;
    if (!selectItem.props.doNotPrefetch) {
      alerts.push({
        key: `select-not-prefetch-${selectItemId}`,
        showItemId: selectItemId,
        alert: `${mgr.name} exists for Select with itemId [${selectItemId}]. Hence the Select should have 'Do not prefetch' checked!`,
        itemId,
        severity: 'warning',
        fix: () => {
          const _page = { ...platform.getPage(appUid, pageId) };
          const _item = _page[selectItemId] as SelectItem;
          let updatedItem = _item;
          updatedItem = {
            ...updatedItem,
            props: {
              ...updatedItem.props,
              doNotPrefetch: true,
            },
          };
          _page[_item.itemId] = updatedItem;
          platform.setter(pageAtom, _page, {
            params: { appUid, pageId },
          });
        },
      });
    }
  }
  return [alerts, autoFixes];
}
